<footer>
  <div id="app-footer" class="container-fluid footer" >
      <div id="app-footer-info"  class="row logo-margin pull-right">
        <p class="poweredBy">Powered By</p>
          <span class="col-md-12">
              <img class="footer-image" src="../../assets/images/footer-logo.png">
        </span>
      </div>
  </div>
</footer>